import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class SuIcKapiListeAPI extends BaseAPI {


  constructor() {
    const baseUrl = environment.API_URL + "SuIcKapiListe";
    super(baseUrl);
  }


  getSuIcKapiListe(disKapiNo: string, mahalleKodu: number, caddeSokakKodu: number) {
    return this.get("", { params: { disKapiNo: disKapiNo, mahalleKodu: mahalleKodu, caddeSokakKodu: caddeSokakKodu } })

  }

}


export default new SuIcKapiListeAPI();
class SuIcKapiListeRequest {
  public disKapiNo: string;
  public mahalleKodu: number;
  public caddeSokakKodu: number;


  constructor(disKapiNo: string, mahalleKodu: number, caddeSokakKodu: number) {


    this.mahalleKodu = mahalleKodu;
    this.caddeSokakKodu = caddeSokakKodu;
    this.disKapiNo = disKapiNo;


  }
}
export { SuIcKapiListeRequest };